// Main is the entry component for the authenticated layout.
// It validates the user, handles layout state and renders dialogs.

import React, { useState, useContext } from "react";
import { Redirect } from "react-router-dom";
import { MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import AuthContext from "../../connections/auth/AuthProvider";
import ChangePasswordDialog from "../../components/Dialog/ChangePasswordDialog";
import ChangeProjectDialog from "../../components/Dialog/ChangeProjectDialog";
import MainContent from "./mainContent";
import useProjectSwitcher from "./projectChange";

export default function Main() {
  const { user, userDetails, logoutUser, authTokens } = useContext(AuthContext);

  // Redirect to login if not authenticated
  if (!user || !userDetails) {
    const currentPath = window.location.pathname + window.location.search;
    const redirectTo = `/auth/login${userDetails ? `?redir=${currentPath}` : ""}`;
    return <Redirect to={redirectTo} />;
  }

  const T_PREFIX = "global.layouts";
  const { t } = useTranslation("translation", { keyPrefix: T_PREFIX });

  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
  const [changeProjectModalOpen, setChangeProjectModalOpen] = useState(false);

  const { currentProject, changingProject, setCurrentProject, confirmChange } =
    useProjectSwitcher(userDetails.implementation_code, authTokens, logoutUser);

  // Generate project select options
  const projectOptions = () => {
    if (userDetails.implementation_ids.length > 1) {
      return userDetails.implementation_ids.map((imp, key) => (
        <MenuItem value={imp[0]} key={key}>
          {imp[1] +
            (imp[0] === userDetails.implementation_code
              ? ` (${t("change_project.current")})`
              : "")}
        </MenuItem>
      ));
    }
    // Return a single option for the current project when there's only one
    return [
      <MenuItem value={userDetails.implementation_code} key={0}>
        {userDetails.implementation_ids[0]?.[1] ||
          userDetails.implementation_code}
      </MenuItem>,
    ];
  };

  return (
    <>
      <MainContent
        setChangePasswordModalOpen={setChangePasswordModalOpen}
        setChangeProjectModalOpen={setChangeProjectModalOpen}
      />
      {!userDetails.social_login && (
        <ChangePasswordDialog
          open={changePasswordModalOpen}
          setOpen={setChangePasswordModalOpen}
          userDetails={userDetails}
        />
      )}
      <ChangeProjectDialog
        open={changeProjectModalOpen}
        setOpen={setChangeProjectModalOpen}
        projectOptions={projectOptions}
        currentProject={currentProject}
        changingProject={changingProject}
        handleChangeProjectSelect={(e) => setCurrentProject(e.target.value)}
        handleChangeProjectConfirm={confirmChange}
        userDetails={userDetails}
      />
    </>
  );
}
